'use client';

import { IconScaleTwo } from '@vs-shop/ui/icons';
import type { ClassValue } from 'clsx';
import {
  ProductPanelTool,
  ProductPanelToolLabel,
  ProductPanelToolVariant,
  productPanelToolMarkVariants,
} from '@vs-shop/commerce-ui/productPanelTools';
import { clsxm } from '@vs-shop/utils';
import { useIntl } from 'react-intl';

import { removeProductCodeAtom } from '@vs-shop/engine/atom/productsComparison/productsComparison';
import { useAtomSet } from '@effect/atom-react';

type Props = {
  productCode: string;
  className?: ClassValue;
};

export function ProductPanelComparisonRemove({ productCode, className }: Props) {
  const intl = useIntl();

  const removeFromComparison = useAtomSet(removeProductCodeAtom);

  const handleRemoveFromComparison = () => {
    removeFromComparison(productCode);
  };

  return (
    // The on state of the same toggle, and the tool that undoes rather than
    // does — so the hover goes to the warning colour rather than to the ink.
    <ProductPanelTool
      onClick={handleRemoveFromComparison}
      aria-pressed
      className={clsxm(className)}
    >
      <IconScaleTwo
        className={clsxm(
          'size-6',
          productPanelToolMarkVariants({ variant: ProductPanelToolVariant.DESTRUCTIVE })
        )}
      />
      <ProductPanelToolLabel variant={ProductPanelToolVariant.DESTRUCTIVE}>
        {intl.formatMessage({
          id: 'component.server.page.product.panel.productPanelCompareFavorite.remove',
          defaultMessage: 'Odebrat z porovnání',
        })}
      </ProductPanelToolLabel>
    </ProductPanelTool>
  );
}
